import type { SxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import React from 'react'

import { LuneThemeNew } from '../theme'

const { typography } = LuneThemeNew

const LabeledFormSection = ({
    title,
    subTile,
    children,
    sx,
    titlePros,
    titleRightComponent,
    nested = false,
}: {
    children: React.ReactNode
    title: string
    subTile?: React.ReactNode
    sx?: SxProps
    titlePros?: Record<string, any>
    titleRightComponent?: React.ReactNode
    nested?: boolean
}) => {
    return (
        <Container disableGutters sx={sx}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: subTile || nested ? 1 : 4,
                }}
            >
                <Typography
                    variant={nested ? 'body2' : 'h6'}
                    sx={nested ? { fontWeight: typography.fontWeightMedium } : undefined}
                    {...(titlePros || {})}
                >
                    {title}
                </Typography>
                {titleRightComponent && titleRightComponent}
            </Box>
            {subTile && (
                <Typography variant="body3" color={`Grey700`}>
                    {subTile}
                </Typography>
            )}
            <Container
                disableGutters
                sx={{
                    mt: nested ? 2 : 4,
                }}
            >
                {children}
            </Container>
        </Container>
    )
}

export default LabeledFormSection
